<template>
  <div class="tw:flex tw:sm:flex-row tw:flex-col">
    <div
      class="tw:text-sm tw:bg-green-100 tw:rounded-t-xl tw:sm:rounded-t-none tw:sm:rounded-l-xl tw:sm:w-1/2 tw:p-3"
      data-testid="plus-benefits-section"
    >
      <h4 data-testid="plus-benefits-header" class="tw:font-bold tw:mb-2">
        {{ $t('benefit_comparsion_header_plus') }}
      </h4>
      <ul data-testid="plus-benefits-list" class="tw:flex tw:flex-col tw:gap-y-[2px] tw:mb-2">
        <li v-for="(item, index) in PLUS_BENEFITS" :key="index" class="tw:flex tw:gap-x-3">
          <img :src="CheckIcon" alt="Check Icon" class="tw:w-6 tw:h-6" />
          <span v-if="index === 0">{{
            $t(item, {
              PercentageIncrease: formatPercentage(language, 10, 0, 2),
            })
          }}</span>
          <span v-else>{{ $t(item) }}</span>
        </li>
      </ul>
      <p class="tw:text-gray-600 tw:text-xs">{{ $t('plus_benefit_disclaimer') }}</p>
    </div>
    <div
      class="tw:text-sm tw:bg-gray-200 tw:rounded-b-xl tw:sm:rounded-bl-none tw:sm:rounded-r-xl tw:sm:w-1/2 tw:p-3"
      data-testid="no-plus-section"
    >
      <h4 data-testid="no-plus-header" class="tw:font-bold tw:mb-2">{{ $t('benefit_comparison_header_no_plus') }}</h4>
      <ul data-testid="no-plus-list" class="tw:flex tw:flex-col tw:gap-y-[2px]">
        <li v-for="(item, index) in NO_PLUS_BENEFITS" :key="index" class="tw:flex tw:gap-x-3">
          <img :src="getNoPlusIcon(index)" :alt="$t(getNoPlusIconAlt(index))" class="tw:w-6 tw:h-6" />
          <span>{{ $t(item) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import { formatPercentage } from '@/utils/Utility.ts'
import { useSessionValues } from '@/composables/useSessionValues'

import CheckIcon from '@/assets/img/studio-plus/CheckIcon.svg'
import CrossIcon from '@/assets/img/studio-plus/CrossIcon.svg'

const { language } = useSessionValues()

const PLUS_BENEFITS = ['plus_benefit_1', 'plus_benefit_2', 'plus_benefit_3', 'plus_benefit_4', 'plus_benefit_5']
const NO_PLUS_BENEFITS = [
  'no_plus_example_1',
  'no_plus_example_2',
  'no_plus_example_3',
  'no_plus_example_4',
  'tbs_basic_features',
]

const getNoPlusIcon = index => {
  return index === NO_PLUS_BENEFITS.length - 1 ? CheckIcon : CrossIcon
}

const getNoPlusIconAlt = index => {
  return index === NO_PLUS_BENEFITS.length - 1 ? 'benefit_comparsion_header_plus' : 'benefit_comparison_header_no_plus'
}
</script>
